import {qspost} from '@/plugins/axios'

/*
 * 通知列表
 * @constructor jack
 * */
export const noticeList = (searchTitle, page, pageSize) => qspost('/Index/Notice/noticeList', {
  searchTitle, page, pageSize
})

/*
 * 通知列表详情
 * @constructor jack
 * */
export const noticeDetail = (noticeId) => qspost('/Index/Notice/noticeShow', {
  noticeId
})

/*
 * 通知列表 修改 / 新增
 * @constructor jack
 * */
export const noticeAdd = (title, content, jianjie, noticeId) => qspost('/Index/Notice/noticeAdd', {
  title, content, jianjie, noticeId
})

/*
 * 通知列表删除
 * @constructor jack
 * */
export const noticeDel = (noticeId) => qspost('/Index/Notice/noticeDel', {
  noticeId
})